module.exports = __webpack_public_path__ + "static/media/map_3-1.59a42ba4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/v2/map_3-1.svg
// module id = 762
// module chunks = 0